import {
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
  deleteAction,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { YoutubeModel } from '@models/youtube.model';
import { Dictionary } from '@ngrx/entity/src/models';

export interface CreateYoutubeTableConfigDependencies {
  toRemoveList: Dictionary<boolean>;
}

export function createYoutubeTableConfig(
  dependencies: CreateYoutubeTableConfigDependencies,
): DatasetTableConfig<YoutubeModel.YoutubeMongoDocument> {
  return new TableConfigBuilder<YoutubeModel.YoutubeMongoDocument>()
    .columns([
      textColumn<YoutubeModel.YoutubeMongoDocument>(
        'name',
        'YOUTUBE.TABLE.NAME',
        {
          width: 'minmax(200px, 1fr)',
          mobileVisible: true,
        },
      ),
      textColumn<YoutubeModel.YoutubeMongoDocument>(
        'url',
        'YOUTUBE.TABLE.URL',
        {
          width: 'minmax(100px, 1fr)',
          mobileVisible: true,
          cardIcon: 'ui-icon-link',
        },
      ),
    ])
    .actions([
      deleteAction<YoutubeModel.YoutubeMongoDocument>({
        tooltip: 'YOUTUBE.TABLE.DELETE',
        visible: (row) => !dependencies.toRemoveList[row._id],
      }),
    ])
    .trackBy('_id')
    .build();
}
